import React, { FC } from "react";

import { Guide, GuideUserStatus } from "@mapmycustomers/shared/types/entity";
import { LoadingSpinner } from "@mapmycustomers/ui";

import NoRows from "../../NoRows";

import GuideCard from "./GuideCard";
import styles from "./Guides.module.scss";

export interface GuidesProps {
  guides: Guide[];
  guidesStatusMap: Record<Guide["id"], GuideUserStatus>;
  loading?: boolean;
  onResetFilters?: () => void;
}

const Guides: FC<GuidesProps> = ({ guides, guidesStatusMap, loading, onResetFilters }) => {
  return loading ? (
    <LoadingSpinner global />
  ) : guides.length ? (
    <div className={styles.container}>
      {guides
        // this filtering is not needed for member view, but required
        // for owners when they switch from all guides view
        .filter((guide) => guide.id in guidesStatusMap)
        .map((guide) => (
          <GuideCard guide={guide} guideStatus={guidesStatusMap[guide.id]} key={guide.id} />
        ))}
    </div>
  ) : (
    <NoRows onResetFilters={onResetFilters} />
  );
};

export default Guides;
